import * as React from 'react';
export const SvgAlarmWarning = (props) => {
    return (React.createElement("svg", { viewBox: '0 0 16 16', width: '1rem', height: '1rem', ...props },
        React.createElement("path", { d: 'M.5 14.531h15L8 .469z', fill: '#fff200' }),
        React.createElement("path", { d: 'M8 2.125L14.333 14H1.667zM8 0L0 15h16zm1 13H7v-2h2zm0-8H7v4.667h2z' })));
};
export default SvgAlarmWarning;
